import { registerPlugin } from '@capacitor/core'
import { platform } from '@/services/platform'

export type StorefrontLocation = 'USA' | string

interface StorefrontLocationPlugin {
  getLocation(): Promise<{ location: StorefrontLocation }>
}

const storefrontLocationPlugin =
  registerPlugin<StorefrontLocationPlugin>('StorefrontLocation')

/**
 * Get the iOS storefront location.
 *
 * Return values can be:
 * - 'USA': the US storefront
 * - 'ESP', 'UKR': other locations
 * - null: in case of error or trying to get the location not from iOS
 */
export async function getIosStorefrontLocation(): Promise<StorefrontLocation | null> {
  const isIOS = await platform.isNativeIOSApp()
  if (!isIOS) {
    return null
  }

  // This is wrapped in a try/catch block because on iOS<15 the plugin won't work
  // and therefore will throw an error.
  try {
    const { location } = await storefrontLocationPlugin.getLocation()
    return location
  } catch (error) {
    return null
  }
}
